export const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: '#0003', // Control background color
      borderColor: '#34495e', // Border color
      borderRadius: '8px', // Border radius
      color: 'white', // Text color
      padding: '10px', // Padding inside the control
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: '#0003', // Menu background color
      borderRadius: '8px', // Menu border radius
      color: 'white', // Text color in the menu
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? '#1abc9c' : isFocused ? '#16a085' : '#34495e', // Focused and selected options
      color: 'white', // Option text color
      padding: '10px', // Option padding
    }),
    placeholder: (styles) => ({
      ...styles,
      color: 'white', // Placeholder text color
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'white', // Color of the selected value
    }),
  };